import type { CurrencyRegistry } from "./CurrencyRegistry";
import { MoneyFormatter } from "./MoneyFormatter";
import type { MoneyContext } from "./MoneyContext";

export function createMoneyContext(input: {
  currencyCode: string;
  denominationFactor: number;
  registry: CurrencyRegistry;
}): MoneyContext {
  const formatter = new MoneyFormatter({
    currencyCode: input.currencyCode,
    denominationFactor: input.denominationFactor,
    registry: input.registry,
  });

  return {
    currencyCode: input.currencyCode,
    denominationFactor: input.denominationFactor,
    formatter,
  };
}